export default __webpack_public_path__ + "static/media/ic-remove.7d282301.svg";